// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2tTyt","content":"RecentSearches_content__3193A"};